import { SEARCH_QUERY_START } from "../actionType";

export const searchAction = (url, query, page, actionForRedux) => ({
  type: SEARCH_QUERY_START,
  url,
  query,
  page,
  actionForRedux,
});
